import { Margin, Width } from "@twilio-paste/core/style-props";

export interface CompositeFileUploaderProps {
  acceptedFileTypes?: string[];
  disabled?: boolean;
  dropZoneHeight?: string;
  files?: File[];
  helpText?: string;
  id: string;
  label?: string;
  marginBottom?: Margin;
  maxFileSize?: number;
  name: string;
  onChange: (files: File[], hasError: boolean) => void;
  onRemove: (file: File, hasError: boolean) => void;
  required?: boolean;
  width?: Width;
}

// Created a mapping here due to TS errors when trying to apply a string
export enum PasteFileUploaderItemVariant {
  default = "default",
  error = "error",
  loading = "loading",
}

export interface CompositeFileUploaderFile {
  file: File;
  description: string;
  title: string;
  variant: PasteFileUploaderItemVariant;
}

export interface FormatFileArgs {
  file: File;
  maxFileSize: number;
}

export interface HandleFormatFilesReturn {
  hasInvalidFile: boolean;
  formattedFiles: CompositeFileUploaderFile[];
}

export interface FormatFileReturn {
  formattedFile: CompositeFileUploaderFile;
  isValid: boolean;
}

export enum FileSizeMeasurement {
  kb = "KB",
  mb = "MB",
  gb = "GB",
}

export interface ValidateFileSizeReturn {
  isValid: boolean;
  friendlyFileSize: string;
}
